import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import {isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import BreadcrumbContextProvider from '../navigation/BreadcrumbContext';
import CategoryBreadcrumb from '../navigation/CategoryBreadcrumb';
import { PrematchContext } from '../Prematch';

function TournamentMenuNavbar(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const sportPath = [props.sport.urlPath, props.sport.urlPathSuffix].join('')
    const relativeSportPath = useAbsolutePath(sportPath,null,props.sport.urlPathSeo,true);  
    const noFollow = isSeoSettingsNoFollow(props.sport.urlPathSeoSettings);
    
    function handleGoBack() {
        prematchContext.openSport(props.sportSc || props.sport);
        //window.history.back();
    }

    // function handleOnClick(){
        // appContext.setHandleOpenFromPath(true)

    // }

    return (
        <>
            
                <nav id="nav-go-back" className="nav-go-back">
                    {/* <Link to={encodeURI(relativeSportPath) } onClick={handleOnClick} {...(noFollow ? {rel: 'nofollow'}:{})} > */}
                        <div className="arrow-container" onClick={handleGoBack}>
                            <div className="arrow arrow-left"></div>
                        </div>
                    {/* </Link> */}
                    <div className="title-container">
                        <span className="nav-section-title" id="nav-section-title">
                            <BreadcrumbContextProvider>
                                <CategoryBreadcrumb desc={props.category.descrizione} categories={props.sport.categories} selected={props.category.id} />
                            </BreadcrumbContextProvider>
                        </span>
                    </div>
                </nav>
        </>
    );
}

export default TournamentMenuNavbar;